// extracted by mini-css-extract-plugin
export default {"bannerCarousel":"bannerCarousel__bannerCarousel__yJnOk"};